module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABO0lEQVR42u3avWoCQRSG4a2scgepJHXANpWz0+dicgc2IthYpNFCrLyDdFapAqkCqRRRxEYQTC/IkW9l/WUhxYbAzFt8MM45U/i4M+vCJmaWxJwEAAAAAAAAAAAAAAAAIgdImnUrM7sfX2qW9w+lBgAAAAAAAAAAAAAAAAAA4N8AvmfevqZpvACNUZolWoDHrssSJYAu/7xX46AB5ktvn5P0Ii9v7tir8XVda4IBWK+8PQ/dr9eqV2uC2wKd99QqreI1qqkn6DNAl3f19bZfc6pFcQjWerfbQXNR3AV0uOU9d+1D8s/XB1+QANrjqj/1nU0XPovGmiva/0EB1Acu+/e33ZzmNNacakED6It+jIt/ZdXOYXgaBAAAAAAAAAAAAAAAAAAAAOCPAXhTFAAAAAAAAAAAAAAAAKLKHs++kSj8y71yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Senegal.png
// module id = v/nh
// module chunks = 0 62 63